<template>
  <div class="app-inner">
    <el-form :inline="true">
      <el-form-item label="物品名称">
        <el-input v-model="queryInfo.assetsName" clearable placeholder="请输入物品名称"/>
      </el-form-item>
      <!-- <el-form-item label="申请人">
        <el-input v-model="queryInfo.applyUser" clearable placeholder="请输入申请人"/>
      </el-form-item> -->
      <el-form-item label="审核状态">
        <el-select v-model="queryInfo.status" clearable placeholder="请选择审核状态">
          <el-option
          v-for="item in ApprovalStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="编号">
        <el-input v-model="queryInfo.eventId" clearable placeholder="请输入编号"/>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="primary" @click="addNew('new')">发起申请</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="query">
        <el-tab-pane label="我的申请" name="queryMine"></el-tab-pane>
        <!-- <el-tab-pane label="待我审批" name="queryMyAudit"></el-tab-pane> -->
        <el-tab-pane label="待我审批" name="queryMyAudit">
          <div slot="label">
            待我审批
                <el-badge :value='workNumber' style="margin-bottom:20px"></el-badge>
          </div>
        </el-tab-pane>
      <el-tab-pane label="已审批" name="queryApproval"></el-tab-pane>
    </el-tabs>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    >
      <template #operate={row}>
        <el-button type="text" size="small" v-if="row.status === 1 && activeName != 'queryApproval'"
          @click="exportDetails(row.id)">导出申请单</el-button>
        <!--1. 我的申请 审核不通过 已拒绝  2. 新增提交暂存 -->
        <el-button type="text" size="small"
          v-if="row.status === 2 && activeName == 'queryMine' || row.status === 10 && activeName == 'queryMine'" @click="update('new', row.id)">修改</el-button>
        <!--1. 我的申请 待审核 -->
          <el-button type="text" size="small" @click="approval('approval', row.id)" v-if="row.status === 0 && activeName == 'queryMine'">催批</el-button>
        <el-button type="text" size="small" @click="add('details', row.id)">查看详情</el-button>
      </template>
    </table-list>
    <apply-dialog ref="Apply" @addSuccess="query"/>
    <download ref="Download"/>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import ApplyDialog from './applyDialog.vue'
import { ApprovalStatus } from '@/utils/constants'
import { compApplyAssetsReceive } from '@/api/assets.js'
import Download from './download.vue'
export default {
  data () {
    return {
      ApprovalStatus: ApprovalStatus,
      page: 1,
      pageSize: 10,
      totalCount: 0,
      workNumber: 0,
      tableData: [],
      queryInfo: {
        assetsName: '',
        status: '',
      },
      loading: false,
      columnDefs: [
        { label: '申请单编号', prop: 'eventId' },
        { label: '资产编号', prop: 'assetsNo' },
        { label: '物品名称', prop: 'assetsName' },
        { label: '品牌', prop: 'brand' },
        { label: '领用数量', prop: 'amount' },
        { label: '申请人', prop: 'applyUser' },
        {
          label: '审核人',
          formatter: (row) => {
            return row.auditPerson || row.preAuditPerson
          }
        },
        {
          label: '审核状态',
          formatter: (row) => {
            let status = ApprovalStatus.find(item => item.value === row.status)
            return status?.label || ''
          }
        },
        { label: '申请时间', prop: 'createTime' },
        { label: '操作', prop: 'operate', width: 240 }
      ],
      activeName: 'queryMine'
    }
  },
  methods: {
    query () {
      this.page = 1
      this.getData()
    },
    getData () {
      this.loading = true
      let type = this.activeName === 'queryMyAudit' ? 'queryMyAudit' : this.activeName === 'queryMine' ? 'queryMine' : 'listApplyAudited'
      compApplyAssetsReceive(type, {
        ...this.queryInfo,
        pageSize: this.pageSize,
        pageNum: this.page,
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
        this.getNum()
      })
    },
    getNum() {
      compApplyAssetsReceive('queryMyAudit', {
        pageNum: this.page,
        pageSize: this.pageSize,
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.workNumber = result.total
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    add (type = 'new', id = '') {
      this.$refs.Apply.showDetails(type, id, this.activeName)
      this.$refs.Apply.actionType = type
    },
    update(type = 'update', id = '') {
      this.$refs.Apply.showDetails(type, id, this.activeName)
      this.$refs.Apply.actionType = 'update'
    },
    addNew (type = 'new', id = '') {
      this.$refs.Apply.showDetails(type, id, 'queryMine')
      this.$refs.Apply.actionType = 'new'
    },
    exportDetails(id) {
      this.$refs.Download.getDetails(id)
    },
    async approval(type = 'new', id = '') {
      this.$confirm('此操作将进行催批, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': id
        }
        let res = await compApplyAssetsReceive('sendSmsAuditPersonAgain', params)
        if (res.code === 0) {
          this.$message({ type: 'success', message: '催批成功!' })
        }
        await this.getData()
      })
    },
  },
  components: {
    TableList,
    Download,
    ApplyDialog
  },
  mounted() {
    this.query()
  }
}
</script>
